var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIncomes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 63.5,
    stroke: "url(#paint0_linear_2577_2867)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.0934 35.2188H55.4371V40.0625C55.4371 41.358 56.4854 42.4063 57.7809 42.4063H67.1559C68.4513 42.4063 69.4996 41.358 69.4996 40.0625V35.2188H71.8434C72.7909 35.2188 73.647 34.6489 74.0085 33.7722C74.3724 32.8957 74.171 31.8885 73.5004 31.2178L64.1254 21.6866C63.2099 20.7711 61.7266 20.7711 60.8112 21.6866L51.4362 31.2178C50.7656 31.8885 50.5642 32.8955 50.9281 33.7722C51.2898 34.6489 52.1459 35.2188 53.0934 35.2188Z",
    fill: "url(#paint1_linear_2577_2867)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5625 63.5C73.207 63.5 64.8125 71.8945 64.8125 82.25C64.8125 92.6051 73.207 101 83.5625 101C93.918 101 102.312 92.6051 102.312 82.25C102.312 71.8945 93.918 63.5 83.5625 63.5ZM87.4898 90.6848C86.9822 90.9386 86.45 91.1384 85.9055 91.2897V91.9373C85.9055 93.2317 84.8561 94.2811 83.5617 94.2811C82.2673 94.2811 81.218 93.2317 81.218 91.9373V91.363C80.2423 91.1173 79.3325 90.7044 78.5617 90.1264C77.5262 89.3498 77.3162 87.8808 78.093 86.8451C78.8697 85.8098 80.3387 85.5997 81.3742 86.3764C82.3117 87.0795 84.1148 87.1317 85.3934 86.4923C85.9073 86.2353 86.1847 85.9259 86.1847 85.7655C86.1847 85.485 86.1847 85.4417 85.8728 85.2753C85.2612 84.9489 84.18 84.7483 83.1342 84.5544C81.7381 84.2953 80.2945 84.0275 79.0436 83.3598C77.2169 82.3848 76.2512 80.7853 76.2512 78.7342C76.2512 76.6808 77.4826 74.8873 79.6297 73.8139C80.1386 73.5594 80.672 73.358 81.218 73.2066V72.5623C81.218 71.268 82.2673 70.2186 83.5617 70.2186C84.8561 70.2186 85.9055 71.268 85.9055 72.5623V73.1362C86.8812 73.382 87.7909 73.7953 88.5617 74.3733C89.5973 75.15 89.8072 76.6191 89.0305 77.6545C88.2537 78.69 86.785 78.9 85.7492 78.1233C84.8103 77.4191 83.0056 77.3669 81.7259 78.0064C81.2091 78.2648 80.9387 78.5681 80.9387 78.7341C80.9387 79.0147 80.9387 79.0578 81.2506 79.2244C81.8622 79.5508 82.9436 79.7514 83.9892 79.9453C85.3853 80.2044 86.8289 80.4722 88.08 81.1398C89.9065 82.1148 90.8722 83.7144 90.8722 85.7655C90.8723 87.817 89.6394 89.61 87.4898 90.6848Z",
    fill: "url(#paint2_linear_2577_2867)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7187 54.125H85.9062C87.2006 54.125 88.25 53.0756 88.25 51.7812V49.4375C88.25 48.1431 87.2006 47.0938 85.9062 47.0938H43.7187C42.4244 47.0938 41.375 48.1431 41.375 49.4375V51.7812C41.375 53.0756 42.4244 54.125 43.7187 54.125Z",
    fill: "url(#paint3_linear_2577_2867)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6875 96.3125V98.6562C36.6875 99.9506 37.7369 101 39.0312 101H69.645C67.1023 99.1069 64.9892 96.7184 63.3853 93.9688H39.0312C37.7369 93.9688 36.6875 95.0181 36.6875 96.3125Z",
    fill: "url(#paint4_linear_2577_2867)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6875 72.875V75.2187C36.6875 76.5131 37.7369 77.5625 39.0312 77.5625H60.5987C61.1148 75.03 62.1222 72.6967 63.3853 70.5312H39.0312C37.7369 70.5312 36.6875 71.5806 36.6875 72.875Z",
    fill: "url(#paint5_linear_2577_2867)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3437 89.2812H61.3217C60.6125 87.0473 60.125 84.7156 60.125 82.25H34.3437C33.0494 82.25 32 83.2994 32 84.5937V86.9375C32 88.2319 33.0494 89.2812 34.3437 89.2812Z",
    fill: "url(#paint6_linear_2577_2867)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3437 65.8437H66.867C71.1219 61.5142 77.0273 58.8125 83.5625 58.8125H34.3437C33.0494 58.8125 32 59.8619 32 61.1562V63.5C32 64.7944 33.0494 65.8437 34.3437 65.8437Z",
    fill: "url(#paint7_linear_2577_2867)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2577_2867",
    x1: 6.88643,
    y1: 18.7399,
    x2: 119.853,
    y2: 75.2731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A632"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2577_2867",
    x1: 52.01,
    y1: 24.134,
    x2: 71.9033,
    y2: 35.0346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A632"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2577_2867",
    x1: 66.83,
    y1: 68.9902,
    x2: 99.9256,
    y2: 85.5526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A632"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2577_2867",
    x1: 43.8969,
    y1: 48.1232,
    x2: 48.1613,
    y2: 62.3503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A632"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2577_2867",
    x1: 38.4606,
    y1: 94.9982,
    x2: 44.0541,
    y2: 108.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A632"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2577_2867",
    x1: 38.1238,
    y1: 71.5607,
    x2: 44.514,
    y2: 83.7031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A632"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2577_2867",
    x1: 33.5775,
    y1: 83.2794,
    x2: 39.6199,
    y2: 95.8894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A632"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2577_2867",
    x1: 34.7741,
    y1: 59.8419,
    x2: 38.707,
    y2: 74.2756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A632"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomes);
export default __webpack_public_path__ + "static/media/incomes.009a384ae697202627b7c84794408cf4.svg";
export { ForwardRef as ReactComponent };